import { useEffect, useState } from 'react';
import { getAllProfesionalesActivosService } from '../services/data.service';

export function useProfessionalsActive () {
    const [professionals, setProfessionals] = useState([]);
    useEffect(() => {
        const getProfessionals = async () => {
            try {
                const profs = await getAllProfesionalesActivosService();
                setProfessionals(profs);
            } catch (err) {
                console.log(err);
            }
        };
        getProfessionals();
    }, []);
    return { professionals };
}
